export const requestQuote = () => {
    let requestQuoteScrollTimeoutId: number;
    const checkRequestQuoteYScroll = () => {

        const button = document.getElementById("js-request-quote");
        const footer = document.querySelector(".footer");
        const footerHeight = footer ? footer.clientHeight - 35 : 0;
        const body = document.body;
        const html = document.documentElement;
        const documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;

        const ls = localStorage.getItem('gtm');
        let plusBottom = 0;
        if (!ls) {
            plusBottom = 80;
        }

        if ((scrollY + windowHeight) > (documentHeight - footerHeight)) {
            if (button) {
                button.style.bottom = footerHeight + "px";
                button.style.position = "absolute";
            }
        } else {
            if (button) {
                button.style.bottom = plusBottom + "px";
                button.style.position = "fixed";
            }
        }

    }
    const button = document.getElementById("js-request-quote");
    if (button) {
        checkRequestQuoteYScroll();
        window.addEventListener("scroll", () => {
            clearTimeout(requestQuoteScrollTimeoutId);
            requestQuoteScrollTimeoutId = setTimeout(checkRequestQuoteYScroll, 10);
            checkRequestQuoteYScroll();
        });
        window.addEventListener("resize", () => {
            clearTimeout(requestQuoteScrollTimeoutId);
            requestQuoteScrollTimeoutId = setTimeout(checkRequestQuoteYScroll, 10);
            checkRequestQuoteYScroll();
        });
    }
}
